"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IconSizeMap = {
  system: {
    1: {
      sm: '16px',
      md: '16px',
      lg: '16px'
    },
    2: {
      sm: '20px',
      md: '20px',
      lg: '20px'
    },
    3: {
      sm: '20px',
      md: '24px',
      lg: '24px'
    },
    4: {
      sm: '24px',
      md: '32px',
      lg: '32px'
    },
    5: {
      sm: '32px',
      md: '36px',
      lg: '36px'
    }
  },
  midLight: {
    1: {
      sm: '36px',
      md: '40px',
      lg: '40px'
    },
    2: {
      sm: '40px',
      md: '48px',
      lg: '48px'
    },
    3: {
      sm: '48px',
      md: '56px',
      lg: '56px'
    },
    4: {
      sm: '56px',
      md: '64px',
      lg: '64px'
    },
    5: {
      sm: '64px',
      md: '72px',
      lg: '72px'
    }
  },
  hifiLight: {
    1: {
      sm: '64px',
      md: '72px',
      lg: '72px'
    },
    2: {
      sm: '72px',
      md: '84px',
      lg: '84px'
    },
    3: {
      sm: '84px',
      md: '96px',
      lg: '96px'
    },
    4: {
      sm: '96px',
      md: '120px',
      lg: '120px'
    },
    5: {
      sm: '120px',
      md: '192px',
      lg: '192px'
    }
  },
  state: {
    1: {
      sm: '64px',
      md: '72px',
      lg: '72px'
    },
    2: {
      sm: '72px',
      md: '84px',
      lg: '84px'
    },
    3: {
      sm: '84px',
      md: '96px',
      lg: '96px'
    },
    4: {
      sm: '96px',
      md: '120px',
      lg: '120px'
    },
    5: {
      sm: '120px',
      md: '192px',
      lg: '192px'
    }
  }
};
const breakPointMap = {
  xs: 'sm',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'lg'
};
const getIconSize = (group, size, breakPoints) => {
  const breakPoint = breakPointMap[breakPoints.current];
  return IconSizeMap[group][size][breakPoint];
};
const CustomIconOrImage = _ref => {
  let {
    name = '',
    size = 3,
    group = 'system',
    src = {},
    state = '',
    iconWidth = null,
    iconHeight = null,
    testId = null
  } = _ref;
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const iconSize = getIconSize(group, size, breakPoints);
  return name ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: name,
    size: size,
    group: group,
    state: state,
    dataAttributes: {
      'data-test-id': testId
    }
  }) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Image, {
    alt: src.alt,
    sm: {
      src: (0, _utils.getImagePath)(src.sm),
      width: iconWidth !== null && iconWidth !== void 0 ? iconWidth : iconSize,
      height: iconHeight !== null && iconHeight !== void 0 ? iconHeight : iconSize
    },
    md: {
      src: (0, _utils.getImagePath)(src.md),
      width: iconWidth !== null && iconWidth !== void 0 ? iconWidth : iconSize,
      height: iconHeight !== null && iconHeight !== void 0 ? iconHeight : iconSize
    },
    lg: {
      src: (0, _utils.getImagePath)(src.lg),
      width: iconWidth !== null && iconWidth !== void 0 ? iconWidth : iconSize,
      height: iconHeight !== null && iconHeight !== void 0 ? iconHeight : iconSize
    },
    xl: {
      src: (0, _utils.getImagePath)(src.xl || src.lg),
      width: iconWidth !== null && iconWidth !== void 0 ? iconWidth : iconSize,
      height: iconHeight !== null && iconHeight !== void 0 ? iconHeight : iconSize
    },
    dataAttributes: {
      'data-test-id': testId
    }
  });
};
var _default = CustomIconOrImage;
exports.default = _default;